/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : apiUrls.ts
 *
 * Project Title : APM Settings Tool
 *
 * Description   : API endpoints
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422335
 *
 * @Date         : Dec 16, 2021
 *
 * @Version      : Version 1.0
 *
 * By            : <Author>
 * On            : <Date Modified>
 * Description   : <Description>
 *
 *
 ******************************************************************************/

export const apiVersion = {
  v1: "/api/v1",
};

export const apmURLs = {
  APM_HISTORY_URL: "/settings-history",
  CUSTOMER_LIST_URL: "/customerAccounts",
  APM_SETTINGS_FILE_LIST_URL: "/apm-settings-files",
  USER_CONTACT_DETAILS: "/user/details",
  AIRCRAFT_DETAILS_MASTER_DATA: "/aircrafts",
  APM_SETTINGS: "/apm-settings",
};
